/**
 * When enabled, the maker sign up state will use React hooks
 */ export var ENABLE_MAKER_SIGN_UP_STATE_HOOKS_MIGRATION_241206 = 'ENABLE_MAKER_SIGN_UP_STATE_HOOKS_MIGRATION_241206';
